<a
  [matTooltip]="'result.hint.menu_icon' | translate"
  class="fa-menu-bar fz-18" (click)="openSecondaryMenu()"></a>
